"use client";

import { PageBadge } from "@/components/backoffice/page-components";
import { getKvpsBrandLogoPath } from "@/lib/kvps";
import { cn } from "@/lib/utils";
import { KvpsComponent } from "./kvps-component";
import { useSession } from "next-auth/react";

function CurrentKvpsBadge() {
  const { data: session } = useSession();
  const kvps = session?.data.kvps.current ?? null;
  const logoPath = getKvpsBrandLogoPath(kvps);

  return (
    <PageBadge
      className={cn(
        "flex max-w-80 flex-col items-center gap-2",
        kvps === null && "bg-yellow-100",
      )}
    >
      {logoPath && (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoPath}
          alt="brand logo"
          className="h-6 shrink-0 object-contain"
        />
      )}
      <span className="flex items-center gap-1 whitespace-nowrap">
        KVPS : <KvpsComponent kvps={kvps} />
      </span>
    </PageBadge>
  );
}

export { CurrentKvpsBadge };
